const EMAIL = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;

/** "a@x.com, b@y.com; c@z.com" → the addresses, and the first one that is not an email. */
export function parseAddresses(text: string): { list: string[]; bad: string | null } {
  const list = text
    .split(/[\s,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  return { list, bad: list.find((a) => !EMAIL.test(a)) ?? null };
}
